import { config } from '../helpers'
import { handleHttpResponse } from '../helpers';

export const LabelService = {
  getLocale,
  getLabel
}


function getLabel(view, locale = 'fr') {
  const requestOptions = {
    method: "GET"
  };

  return fetch(`${config.apiUrl}/label/view?view=${view}&locale=${locale}`, requestOptions)
    .then(handleHttpResponse)
}


function getLocale() {
  // get configured locale by user
  const configuredLocale = localStorage.getItem('locale')
  if (configuredLocale) {
    return configuredLocale
  }

  // get default language from browser
  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language

  // Default app language
  if (!navigatorLocale) {
    return 'fr'
  }

  // Return trimmed (fr-FR -> fr)
  const locale = navigatorLocale.split(/-|_/)[0]
  return ['fr', 'nl', 'de'].includes(locale) ? locale : 'fr';
}